module.exports = __webpack_public_path__ + "static/media/read-notifications.a6bb7607.svg";